// import React from "react";

// export default function AboutPage() {
//   return (
//     <main className="min-h-[70vh] bg-white">
//       {/* Hero */}
//       <section className="bg-gradient-to-r from-amber-50 to-rose-50">
//         <div className="max-w-6xl mx-auto px-4 py-12">
//           <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-slate-900">
//             Razzle Dazzle Entertainment
//           </h1>
//           <p className="mt-2 text-lg text-slate-600">
//             <span className="font-semibold">“Spectrum of Elite Entertainment”</span>
//           </p>
//         </div>
//       </section>

//       {/* Story */}
//       <section className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-3 gap-8">
//         <div className="md:col-span-2">
//           <h2 className="text-xl font-bold text-slate-900">Who we are</h2>
//           <p className="mt-3 text-slate-700 leading-relaxed">
//             We are a full-stack entertainment & events company passionate about curating premium,
//             memorable experiences — from large-scale concerts to bespoke corporate shows and brand activations.
//           </p>

//           <h3 className="mt-8 text-lg font-semibold text-slate-900">What we do</h3>
//           <ul className="mt-3 grid sm:grid-cols-2 gap-3 text-slate-700">
//             <li className="rounded-xl border p-3">Live Concerts & Tours</li>
//             <li className="rounded-xl border p-3">Corporate Events & Offsites</li>
//             <li className="rounded-xl border p-3">College Fests & City Shows</li>
//             <li className="rounded-xl border p-3">Brand Launches & Activations</li>
//           </ul>

//           <h3 className="mt-8 text-lg font-semibold text-slate-900">Our approach</h3>
//           <p className="mt-3 text-slate-700 leading-relaxed">
//             Artist-first programming, meticulous production, and guest delight. We partner end-to-end —
//             concept, curation, permissions, marketing, operations, and on-ground show-running.
//           </p>
//         </div>

//         {/* Quick facts / CTA */}
//         <aside className="rounded-2xl border p-5 bg-amber-50/60">
//           <h4 className="font-semibold text-slate-900">Quick Facts</h4>
//           <ul className="mt-3 space-y-2 text-slate-700">
//             <li>Founder/Director: <b>Dev Joshi</b></li>
//             <li>HQ: <b>Indore</b></li>
//           </ul>
//           <div className="mt-5">
//             <a
//               href="mailto:business.razzledazzle@gmail.com"
//               className="inline-flex items-center justify-center w-full rounded-xl bg-amber-500 text-slate-900 font-semibold px-4 py-2 hover:bg-amber-400"
//             >
//               Business Enquiries
//             </a>
//           </div>
//         </aside>
//       </section>
//     </main>
//   );
// }


// FILE: src/pages/AboutPage.jsx
// Default export component ready to drop into this exact path.
import React from "react";


export default function AboutPage() {
return (
<main className="min-h-screen bg-slate-50">
<div className="border-b border-slate-200 bg-white">
<div className="mx-auto max-w-6xl px-4 py-8">
<h1 className="text-2xl font-semibold text-slate-900">About ShowTimeBro</h1>
<p className="mt-1 text-sm text-slate-600">Connecting audiences with the best events.</p>
</div>
</div>


<div className="mx-auto max-w-6xl px-4 py-8 space-y-6">
<section className="bg-white rounded-lg p-6 shadow-sm">
<h2 className="text-xl font-semibold text-slate-900">Who we are</h2>
<p className="mt-3 text-slate-700 leading-7">
ShowTimeBro is an online platform that helps users discover and book Tickets for events — concerts, theatre, sports, and more. We focus on delivering a simple, secure, and delightful booking experience for audiences and a reliable ticket partner for event organisers.
</p>
</section>


<section className="bg-white rounded-lg p-6 shadow-sm">
<h2 className="text-xl font-semibold text-slate-900">Our mission</h2>
<p className="mt-3 text-slate-700 leading-7">
To make live events accessible to everyone by offering transparent pricing, fast checkout, and excellent customer support — so more people can make memories together.
</p>
</section>


<section className="bg-white rounded-lg p-6 shadow-sm">
<h2 className="text-xl font-semibold text-slate-900">What we offer</h2>
<ul className="list-disc pl-6 mt-3 text-slate-700 space-y-1">
<li>Event discovery and personalised recommendations</li>
<li>Secure payments and instant booking confirmations</li>
<li>Customer support for bookings and post-purchase help</li>
<li>Tools for organisers to manage Tickets and attendees</li>
</ul>
</section>


<section className="bg-white rounded-lg p-6 shadow-sm">
<h2 className="text-xl font-semibold text-slate-900">Values</h2>
<p className="mt-3 text-slate-700 leading-7">
Integrity, user-first design, and collaboration with event partners guide everything we do.
</p>
</section>


</div>
</main>
);
}